'use strict';
define('elements/navigation__inpage',['stickyfill', 'jquery'], function(Stickyfill, $) {
	var stickyElements = document.getElementsByClassName('navigation--inpage');
	for(var i = stickyElements.length - 1; i >= 0; i--) {
		Stickyfill.add(stickyElements[i]);
	}

	var $window = $(window),
		$body = $('body,html'),
		$inPageNav = $('.navigation--inpage'),
		inPageNavHeight = $inPageNav.outerHeight(),
		$activeSection = $('#inpage-item-active'),
		$inPageDropDown = $inPageNav.find('.navigation__list'),
		$chooseSection = $('.navigation--inpage .navigation__item'),
		$tripSections = $('.trip-section');

	$activeSection.click(function() {
		$inPageDropDown.toggleClass('is-visible');
	});

	$chooseSection.click(function() {
		var sectionTitle = $(this).text();

		$activeSection.text(sectionTitle);
		$chooseSection.removeClass('navigation__item--active');
		$(this).addClass('navigation__item--active');
		$inPageDropDown.toggleClass('is-visible');
	});

	if ($body.find($inPageNav).length != 0) {
		var $twoColumn = $inPageNav.siblings('.grid--inverted-large'),
			twoColumnOffset = $twoColumn.offset().top,
			twoColumnHeight = $twoColumn.outerHeight();

		$window.scroll(function () {
			var scrollPosition = $window.scrollTop(),
				fullWidthTrigger = twoColumnOffset + twoColumnHeight + inPageNavHeight;

			if (scrollPosition > fullWidthTrigger) {
				$inPageNav.addClass('has-full-width');
			} else {
				$inPageNav.removeClass('has-full-width');
			}

			$tripSections.each( function() {
				var $section = $(this),
					sectionOffset = $section.offset().top,
					sectionHeight = $section.outerHeight(),
					sectionId = $section.attr('id');

				if ($section.last().length != 0) {
					if (scrollPosition > sectionOffset) {
						$inPageNav.find('a').removeClass('is-active');
						$inPageNav.find('a[href=#' + sectionId + ']').addClass('is-active');
					}

					if (scrollPosition > (sectionOffset + sectionHeight)) {
						$inPageNav.find('a').removeClass('is-active');
					}
				} else {
					var sectionOffsetNext = $section.next().offset().top;

					if (scrollPosition > sectionOffset && scrollPosition < sectionOffsetNext) {
						$inPageNav.find('a').removeClass('is-active');
						$inPageNav.find('a[href=#' + sectionId + ']').addClass('is-active');
					}
				}
			});
		});
	}
});
